import {obtenerNumNoches} from "../Modulo_Motor_Reservas/Funciones/obtenerNumNoches";
import {obtenerDiasPromocion} from "./obtenerDiasPromocion";

export const obtenerValorTotalSaldo = (entidad) => {

    let numNoches = obtenerNumNoches({fechaCheckIn: entidad.fechaCheckIn, fechaCheckOut: entidad.fechaCheckOut});
    let valor = parseInt(entidad.tarifa)
    let valorPromo = parseInt(entidad.valorPromo ? entidad.valorPromo : 0)
    let numDiasPromo = obtenerDiasPromocion({
        fechaCheckIn: entidad.fechaCheckIn,
        diasPromo: entidad.diasPromo,
        numNoches: numNoches
    });
    let diasNormal = numNoches - numDiasPromo

    let valorReserva = (valor * diasNormal) + (valorPromo * numDiasPromo)
    let valorAdicionales = entidad.adicionales ? totalArr(entidad.adicionales) : 0
    let valorDescuentos = entidad.descuentos ? totalArr(entidad.descuentos) : 0
    let valorAbonos = entidad.abonos ? totalArr(entidad.abonos) : 0


    return valorReserva + valorAdicionales - valorDescuentos - valorAbonos;
}


export const totalArr = (arr = []) => {

    let total = 0
    for (let i = 0; i < arr.length; i++) {
        total += parseInt(arr[i].valor)
    }

    return total
}